import { Drawer, Menu } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import menus, { sideMenuItensIconsStyle, topMenuItensIconsStyle } from "../../components/menu/Menus"
import logo from '../../assets/logo.png'
import { useContext } from "react";
import styles from "../../services/styles";
import { displayMessage } from '../../helpers/messages'
import { LoginOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import GeneralContext from "../../context/GeneralContext/GeneralContext";

const { bc1, COLORS } = styles


export default function DrawerMenu() {
  const {
    setLoggedUser,
    isAdmin,
    windowWidth, windowHeight,
  } = useContext(GeneralContext)

  const [collapsed, setCollapsed] = useState(false);
  const [menuDrawerVisible, setMenuDrawerVisible] = useState(false);
  const [menu_selected_keys, setMenuSelectedKeys] = useState([])
  const [menu_selected_title, setMenuSelectedTitle] = useState([])

  const handleOnClickLogout = () => {
    setLoggedUser(null)
  }

  const handleOnClickItemMenu = e => {
    setMenuSelectedKeys([e.key])
    setMenuSelectedTitle([e.item.props.title])
    onCloseDrawer()
  }

  const onCloseDrawer = () => setMenuDrawerVisible(false)
  const onOpenDrawer = () => setMenuDrawerVisible(true)

  const menuOptions = [ ...menus.userSideMenuItens, ...(isAdmin ? menus.adminSideMenuItens : [])]

  const listMobileMenuItens = [
    ...menuOptions.map(
      item => {
        return {
          key: item.key,
          label: (
            <Link
              style={{
                color: menu_selected_keys && menu_selected_keys[0] == item.key ? COLORS.GREEN[900] : 'white',
                fontWeight: menu_selected_keys && menu_selected_keys[0] == item.key ? 'bold' : 'normal',
                fontSize: 16,
                display: 'flex',
                alignItems: 'center',
                gap: 5
              }}
              to={item.key}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {item.icon}

                <span>{item.title}</span>
              </div>
            </Link>
          )
        }
      }
    ),

    ...menus.topMenuItens.map(
      item => {
        return {
          key: item.key,
          label: (
            <Link
              style={{
                color: menu_selected_keys && menu_selected_keys[0] == item.key ? COLORS.GREEN[900] : 'whitesmoke',
                fontWeight: menu_selected_keys && menu_selected_keys[0] == item.key ? 'bold' : 'normal',
                fontSize: 16,
              }}
              to={item.key}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {item.icon}

                <span>{item.title}</span>
              </div>
            </Link>
          )
        }
      }
    ),

    {
      key: '/logout',
      label: (
        <Link
          style={{
            color: 'white',
            fontSize: 16,
            fontWeight: 'normal'
          }}
          to={'/logout'}
          onClick={handleOnClickLogout}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <LoginOutlined style={sideMenuItensIconsStyle} />

            <span>{displayMessage('LOGOUT')}</span>
          </div>
        </Link>
      )
    }
  ]

  return (
    <div>
      <MenuUnfoldOutlined
        style={{ position: 'absolute', top: 20, left: 10, fontSize: 24, marginLeft: 15, color: COLORS.GREEN[900], cursor: 'pointer' }}
        onClick={onOpenDrawer}
      />
      <Drawer
        title={<TitleDrawer />}
        onClose={onCloseDrawer}
        placement="left"
        open={menuDrawerVisible}
        style={{backgroundColor: COLORS.GREEN[100]}}
      >
        <Menu
          mode="inline"
          defaultOpenKeys={['menu']}
          style={{ height: '100%', height: collapsed ? windowHeight - 71 : windowHeight - 120, borderRight: 0, background: COLORS.GREEN[900], paddingTop: 10 }}
          items={listMobileMenuItens}
          onSelect={handleOnClickItemMenu}
        />
      </Drawer>
    </div>

  )
}

const TitleDrawer = () => (
  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 0 }}>
    <p style={{ marginLeft: 10, fontSize: '18px', fontWeight: 600, paddingTop: 10 }}>Menu</p>
    {/* <img
      width={'10%'}
      style={{ marginLeft: '12px', margin: 0, padding: 0 }}
      src={logo}
    /> */}
  </div>
)
